import { useState } from "react";

const navItems = [
  { label: "年度大榜", href: "#annual" },
  { label: "月度瓜榜", href: "#monthly" },
  { label: "热瓜速览", href: "#hot" },
  { label: "深度补课", href: "#deep" },
  { label: "常见问题", href: "#faq" },
  { label: "关于榜单", href: "#about" },
];

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 border-b border-background-200/80 bg-background-50/90 backdrop-blur">
      <div className="mx-auto flex h-16 w-full max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#top" className="flex items-center gap-2 whitespace-nowrap" aria-label="劲爆大瓜 首页">
          <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg"></i>
          </span>
          <span className="font-serif text-xl font-black tracking-tight text-foreground-950">
            劲爆大瓜
          </span>
          <span className="mt-1 hidden text-[10px] font-medium tracking-widest text-primary-600 sm:inline">
            JBGUA 榜单
          </span>
        </a>

        <nav className="hidden items-center gap-6 lg:flex" aria-label="主导航">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm font-medium text-foreground-600 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-3 lg:flex">
          <a
            href="#subscribe"
            className="rounded-full border border-background-200 bg-background-100 px-4 py-2 text-sm font-medium text-foreground-700 whitespace-nowrap transition-colors hover:border-primary-200 hover:text-primary-700"
          >
            <i className="ri-mail-line mr-1.5"></i>订阅榜单
          </a>
          <a
            href="#annual"
            className="rounded-full bg-primary-500 px-5 py-2 text-sm font-semibold text-background-50 whitespace-nowrap transition-colors hover:bg-primary-600"
          >
            查本年度大瓜
          </a>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          className="flex h-10 w-10 items-center justify-center rounded-full text-foreground-700 lg:hidden"
          aria-label={open ? "收起菜单" : "展开菜单"}
          aria-expanded={open}
        >
          <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-3-line"}`}></i>
        </button>
      </div>

      {open && (
        <nav className="border-t border-background-200 bg-background-50 px-4 py-3 lg:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#subscribe"
              onClick={() => setOpen(false)}
              className="mt-2 rounded-full bg-primary-500 px-5 py-2.5 text-center text-sm font-semibold text-background-50"
            >
              订阅榜单 · 不错过每一期
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}